import { AddInsightToCollectionsButton, AddInsightToCollectionsMenuItem } from '@ecosystem/newron-client-collections';
import React from 'react';

import { InsightCollectionDataType, InsightData } from '../../content/collection/types';
import { PageSettingsManager } from '../../page/settings';
import { ComponentHeaderActionType } from '../../page/types';
import { createViewStateFn } from '../../tools/createViewState';
import { MultiKpiCollectionButtonProps } from './types';
import { removeOriginFromCorePageSettings } from '../../content/collection/utils';

export const MultiKpiCollectionButton = ({
  collectionOptions,
  collectionInfo,
  proposition,
  isDisabled,
  paramsForData,
  paramsForContext,
  context,
  dataInfo,
  page,
  componentSettings,
  actionType = ComponentHeaderActionType.Button,
}: MultiKpiCollectionButtonProps) => {
  if (!collectionOptions || !collectionInfo) {
    return null;
  }

  const pageSettings = PageSettingsManager.getInstance().get();

  const createInsightDataForComponent = (dataType: InsightCollectionDataType): InsightData => {
    const insightData: InsightData = {
      content: {
        type: collectionOptions.type,
        dataOptions: collectionOptions.dataOptions,
      },
      proposition: proposition,
      paramsForData,
      paramsForContext,
      dataType,
      corePageSettings: {
        context,
        data: dataInfo,
        page,
        collection: collectionInfo,
        upsellContext: { upsellQualtricsURL: '', upsellAnalyticsURL: '' },
      },
      componentSettings,
      pageSettings,
    };

    return removeOriginFromCorePageSettings(insightData);
  };

  const AddInsightToCollectionComponent =
    actionType === ComponentHeaderActionType.Button ? AddInsightToCollectionsButton : AddInsightToCollectionsMenuItem;

  return (
    <AddInsightToCollectionComponent<InsightData, {}>
      type={collectionOptions.collectionKey}
      selectDataType
      defaultDataType={InsightCollectionDataType.live}
      proposition={proposition}
      disabled={isDisabled}
      createInsightDataFn={createInsightDataForComponent}
      createViewStateFn={createViewStateFn}
    />
  );
};
